import { useAppActions } from 'reducers/slices/public/realEstateAgentsSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { loadRealEstateAgent } = useAppActions();
  const { realEstateAgent, realEstateAgentLoadingStatus } = useSelector(state => state.publicRealEstateAgentsSlice);

  return {
    isRealEstateAgentLoading: useFetchStatus(realEstateAgentLoadingStatus).isPending,
    isRealEstateAgentIdle: useFetchStatus(realEstateAgentLoadingStatus).isIdle,
    loadRealEstateAgent,
    realEstateAgent,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/public/useRealEstateAgents.js